export default __webpack_public_path__ + "static/media/image-error-unauthorized.25d72b77.svg";